export const getErrorMessage = (error: any) => {
    if (typeof error === 'string') {
        return error;
    } else {
        return error.message ? error.message : error.err;
    }
}

export const getValueColor = (value: number) => {
    if (value > 0) {
        return '#4cf350';
    }
    if (value < 0) {
        return '#f74a01';
    }

    return '#fff';
}
